export const IconGrayActionsPlus: {
  name: 'icon_gray_actions_plus-69b54135d376'
} = {
  name: 'icon_gray_actions_plus-69b54135d376'
}
